import React from "react";
import ButtonC from "../button";
import styles from "./index.module.scss";
import { useToast } from "../toast/toast";
import { useAddToCalling } from "../../../hooks/react-query/calling-pipeline/useAddToCalling";
import { useQueryClient } from "@tanstack/react-query";

export default function AddToCalling({
  accountId,
  pubPropertyId
}: {
  accountId: string;
  pubPropertyId: string;
}) {
  const queryClient = useQueryClient();
  const { showError, showSuccess }: any = useToast();
  const AddToCallingMutation = useAddToCalling(
    () => {
      showSuccess("success", "Added to Calling Pipeline.");
      queryClient.invalidateQueries({ queryKey: ["calling-pipeline-list"] });
      queryClient.invalidateQueries({ queryKey: ["flipper-vaults"] });
    },
    (error) => {
      showError("error", error.response.data.message || "something went wrong");
    }
  );
  return (
    <ButtonC
      label="Add to Pipeline"
      size="normal"
      className={styles.AddToCallingPipelineBtn}
      loading={AddToCallingMutation.isPending}
      onClick={() => {
        AddToCallingMutation.mutate({
          acctId: accountId,
          pubPropertyId: pubPropertyId
        });
      }}
    />
  );
}
